/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { MultiSelect, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import AuditRepository from '../../../helpers/api/AuditRepository';
import { api } from '../../../helpers/api/api';
import showNotification from '../../../helpers/notification/BaseNotification';
import { apioperation, entitiesLabels, getError } from '../../../helpers/Constants';

export default class PurchaseOrderMultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: [],
      selectedItems: [],
    };
    this.onChange = this.onChange.bind(this);
    this.repository = new AuditRepository();
  }

  componentDidMount = () => {    
    this.getItems();
  }

  onChange = (selectedItem) => {
    const items = selectedItem ? selectedItem.selectedItems : null;
    this.setState({
      selectedItems: items,
    });
    this.props.onChange(items);
  };

  getItems = () => {
    this.setState({ loading: true });

    api.getAll('/audit/getpurchaseorders')
      .then((response) => {
        const { data } = response;
        this.setState({
          items: data,
          selectedItems: this.props.initialSelectedItems,
        });        
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.PURCHASEORDERS, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          loading: false
        });
      });
  }

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <MultiSelect.Filterable
        id="auditPurchaseOrderSelect"
        name="auditPurchaseOrderSelect"
        invalid={this.props.invalid}
        invalidText={this.props.invalidText}
        disabled={this.state.items < 1 || this.props.disabled}
        placeholder={
          this.state.selectedItems < 1
            ? 'Choose one or more Purchase Order'
            : this.state.selectedItems.map((elem) => elem.name).join(', ')
        }
        itemToString={(item) => (item ? item && item.name : '')}
        items={this.state.items}
        light={false}
        onChange={this.onChange}
        type="default"
        initialSelectedItems={this.props.initialSelectedItems}
      />
    );
  }
}

PurchaseOrderMultiSelect.propTypes = {
  invalid: PropTypes.bool,
  invalidText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  initialSelectedItems: PropTypes.array,
  disabled: PropTypes.bool,
};
PurchaseOrderMultiSelect.defaultProps = {
  invalid: false,
  invalidText: '',
  initialSelectedItems: [],
  disabled: true,
};
